import { useState, useRef } from 'react'

export function useCarouselState() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isDragging, setIsDragging] = useState(false)
  const [dragStartX, setDragStartX] = useState<number>(0)
  const [dragStartY, setDragStartY] = useState<number>(0)
  const [dragDistance, setDragDistance] = useState<number>(0)
  const hasDragged = useRef(false)

  return {
    currentIndex,
    setCurrentIndex,
    isDragging,
    setIsDragging,
    dragStartX,
    setDragStartX,
    dragStartY,
    setDragStartY,
    dragDistance,
    setDragDistance,
    hasDragged,
  }
}
